import type { CommentRole } from '@change-corgi/middle-end-gql-schema';

export const PETITION_ACTIVITY_COMMENT_ROLES: readonly CommentRole[] = [
	'COMMENT',
	'SUPPORTER_COMMENT',
	'VIDEO_COMMENT',
] as const;
